const PatientHistory = () => {
  return <div>patient history</div>;
};

export default PatientHistory;
